"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Postcode = void 0;

var _app = _interopRequireDefault(require("./app"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _a = require('../package.json'),
    name = _a.name,
    version = _a.version,
    homepage = _a.homepage;

console.log("\n   ___  ______________  ___   ________\n  / _ |/ ___/_  __/ _ )/ _ | / __/ __/\n / __ / /__  / / / _  / __ |_\\ \\/ _/  \n/_/ |_\\___/ /_/ /____/_/ |_/___/___/ \n \n" + name + " " + version + " :: Actbase Opensources.\nContact us -> project@actbase.io\n> https://actbase.io/opensource\n> " + homepage + "\n");
var Postcode = _app["default"];
exports.Postcode = Postcode;
var _default = Postcode;
exports["default"] = _default;